import React from "react";

import { StoryQuestion } from "chq";

import PostStoryRightColumn from "./PostStoryRightColumn";
import PostStoryLeftColumn from "./PostStoryLeftColumn";

type PostStoryModalProps = {
  onNextStep: () => void;
  prompt: StoryQuestion;
};

const IntroPage: React.FC<PostStoryModalProps> = ({ onNextStep, prompt }) => (
  <div className="IntroPage row">
    <PostStoryLeftColumn onNextStep={onNextStep} prompt={prompt} />
    <PostStoryRightColumn />
  </div>
);

export default IntroPage;
